/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*
 * //EVO
 * https://support.maestrooo.com/article/286-making-your-theme-compatible-with-ios-15
 * https://gist.githubusercontent.com/bakura10/64acece60136c7dc9a11c01197aeee5b/raw/68b572bd9eb3d2ed35d15636ee58c15db0ea6a25/fix.js
 */

(function() {
  if (window.Flickity) {
    let originalResizeMethod = window.Flickity.prototype.resize,
      lastWidth = window.innerWidth;

    window.Flickity.prototype.resize = function () {
      if (window.innerWidth === lastWidth && this.maxCellHeight > 0) {
        return;
      }

      lastWidth = window.innerWidth;
      originalResizeMethod.apply(this, arguments); // Call original method
    }
  }
})();

(function() {
  window.PhotoSwipe = new Proxy(window.PhotoSwipe, {
    construct(target, args) {
      let instance = new target(...args);

      let originalUpdateSize = instance.updateSize,
        lastWidth = null;

      instance.updateSize = function() {
        if (lastWidth === null || lastWidth !== window.innerWidth) {
          originalUpdateSize(this, arguments);
        }

        lastWidth = window.innerWidth;
      }

      return instance;
    }
  });
})();

//ellipsis after n characters in string (products title truncation plp)
function truncateText(mobile, element, n_characters) {
  if(mobile && element.innerText.length > 43){
    var truncated = element.innerText.substring(0, n_characters) + "...";
    element.innerText = truncated;
    element.classList.add("truncated");
  }
}

async function postRequest(url = "", data = ""){
  const response = await fetch(url, {
      method: "POST",
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: data,
  });
  return response.json(); // parses JSON response into native JavaScript objects
}

/* popup login wishlist */ 
document.addEventListener("click", e=>{
  //open popup login wishlist
  if(e.target.matches("[data-action='trigger-login'], [data-action='trigger-login'] *")){
    document.querySelector("#login-popup").style.display = 'flex';
    document.querySelector("#overlay-popup").style.display = 'block';
  }
  //close login popup wishlist
  if(e.target.matches("#login-popup svg, #login-popup svg *") || e.target.matches("#overlay-popup")){
    document.querySelector("#login-popup").style.display = 'none';
    document.querySelector("#overlay-popup").style.display = 'none';
  }
  //pdp deselect variants
  if(e.target.matches("#OtherChildProducts .SizeSwatch")){
    e.preventDefault();
    var clicked = e.target.closest(".HorizontalList__Item").querySelector("input");
    var groupName = e.target.closest(".HorizontalList__Item").querySelector("input").name;
    var group = document.querySelectorAll(".SizeSwatch__Radio[name=" + groupName + ']');
    var otherGroup = document.querySelectorAll(".SizeSwatch__Radio:not([name=" + groupName + '])');

    //handle self deselect and deselect the same group
    if(!clicked.checked){
      group.forEach(swatch =>{
          swatch.checked = false;
      });
      clicked.checked = true;
    }
    else{
      clicked.checked = false;
    }

    //handle deselect bikini sizes in other product when select soldout size for back in stock
    if(clicked.classList.contains("soldout")){
      otherGroup.forEach(swatch =>{
        swatch.checked = false;
      })
    }
  }
});

document.addEventListener("DOMContentLoaded", ()=>{
  let url = new URLSearchParams(window.location.search);
  //check if there is product item, the grid is on 2 columns and is mobile
  if(document.querySelector(".Grid__Cell")?.classList.contains("1/2--phone") && window.matchMedia('(max-width: 768px)').matches){
    document.querySelectorAll(".Grid__Cell .ProductItem__Title:not(.truncated)")?.forEach(title =>{
      //arguments: mobile, html string, n_characters
      truncateText(true, title, 43);
    })
  }

  if(url.get("register") == "true"){
    if(localStorage.getItem("marketing") == "true"){
      postRequest("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", `g=SA5NA8&email=${window.customer.email}`)
      .then(data => {
        console.log(data);
      });
    }
  }
})

/**
 * Listeners for the management of gift box quantities in the cart, removal, update of cart items quantities
 * Can be turned to a class to improve readability
 */

document.addEventListener("click", (e)=>{

  /**
   * Management of the removal of items from the cart
   */
  if (e.target.matches('a.CartItem__Remove') || e.target.matches('.QuantitySelector__Button[data-quantity="0"]')) {
    // A product was removed from the cart, check if it was the last item
    // If it was the last item, remove the gift box from the cart
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    // Check if there are only 2 items in the cart, one of which is the gift box, and the click was on the other item
    if (document.querySelectorAll('.CartItem').length == 2 && document.querySelector('.CartItem.CartItem__GiftBox') && e.target.matches('.CartItem:not(.CartItem__GiftBox) *')) {
      // Clear the cart
      fetch(Shopify.routes.root + 'cart/clear.js').then(() => {
          if (document.querySelector('body.template-cart')) {
              window.location.href = window.routes.cartUrl; // If I'm on cart page, reload without URL parameter ("?gift=true")
          } else {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
              }));
          }
      });
    } else {
      // Item removal from the cart
      // If there's a gift box in the cart and the click was not on the gift box remove button, check if the gift box quantity needs to be updated, then remove the item
      if (document.querySelector('.CartItem.CartItem__GiftBox') && !e.target.matches('.CartItem.CartItem__GiftBox *')) {
        checkAndUpdateGiftBoxQuantity(e.target.getAttribute('data-line'), 0, parseInt(e.target.closest(".CartItem").querySelector(".QuantitySelector__CurrentQuantity").value), e.target.matches('.CartItem.CartItem__GiftBox *'));
      } else {
        // Either there's no gift box in the cart or the click was on the gift box remove button
        if (e.target.matches('.CartItem.CartItem__GiftBox *')) {
          // The gift box remove button was clicked, remove the item from the cart and hide the gift box checkboxes
          changeItemAndRerenderCart(e.target.getAttribute('data-line'), 0, true);
        } else {
          // There is no gift box in the cart, just remove the item
          changeItemAndRerenderCart(e.target.getAttribute('data-line'), 0);
        }
      }
    }
  }

  /**
   * Limiting the max quantity of the gift box to the total number of items in the cart
   */

  if (e.target.matches('.CartItem.CartItem__GiftBox a[data-action="update-gift-box-quantity"]')) {
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    let giftBoxNewQuantity = parseInt(e.target.getAttribute('data-quantity'));
    let giftBoxLine = e.target.getAttribute('data-line');

    // Get cart current total number of items
    const cartTotalItems = getCartTotalItems();

    // If the new quantity is not higher than the total number of items in the cart, update the gift box quantity
    if (giftBoxNewQuantity <= cartTotalItems) {
      // Update the gift box quantity
      changeItemAndRerenderCart(giftBoxLine, giftBoxNewQuantity);
    } else {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }
  }

  /**
   * Update the gift box quantity when a product is removed and the gift box quantity is higher than the total number of items in the cart
   */

  if (e.target.matches('a[data-action="update-item-quantity-custom"]:not([data-quantity="0"])')) {
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    // If gift box quantity is higher than the total number of items in the cart, update the gift box quantity
    if (document.querySelector('.CartItem.CartItem__GiftBox') && !e.target.matches('.CartItem.CartItem__GiftBox *')) {
      checkAndUpdateGiftBoxQuantity(e.target.getAttribute('data-line'), e.target.getAttribute('data-quantity'));
    } else {
      changeItemAndRerenderCart(e.target.getAttribute('data-line'), e.target.getAttribute('data-quantity'));
    }
  }
});

function checkAndUpdateGiftBoxQuantity(line, quantity, oldQuantity = 1) {
  // If gift box quantity is higher than the total number of items in the cart, update the gift box quantity
  let giftBoxQuantity = parseInt(document.querySelector('.CartItem.CartItem__GiftBox .QuantitySelector__CurrentQuantity').value);
  let giftBoxLine = document.querySelector('.CartItem.CartItem__GiftBox .QuantitySelector__CurrentQuantity').getAttribute('data-line');
  // Get cart current total number of items
  const cartTotalItems = getCartTotalItems() - oldQuantity; // Subtract the old quantity of the item that was removed

  if (giftBoxQuantity > cartTotalItems) {
    // Update the gift box quantity to match the total number of items in the cart, then update the item quantity
    changeItem(giftBoxLine, cartTotalItems)
      .then(() => {
        changeItemAndRerenderCart(line, quantity);
      });
  } else {
    // The quantity of the gift box is lower than the total number of items in the cart, just update the item quantity
    changeItemAndRerenderCart(line, quantity);
  }
}

function getCartTotalItems() {
  let cartItems;
  if (document.querySelector('body.template-cart')) {
    // Get the cart items from the cart page
    cartItems = document.querySelectorAll('.CartItem:not(.CartItem__GiftBox) > .CartItem__Actions .QuantitySelector__CurrentQuantity');
  } else {
    // Cart drawer
    cartItems = document.querySelectorAll('.CartItem:not(.CartItem__GiftBox) .QuantitySelector__CurrentQuantity');
  }

  let cartTotalItems = 0;
  cartItems.forEach(item => {
    cartTotalItems += parseInt(item.value);
  });

  return cartTotalItems;
}

function changeItem(line, quantity) {
  return fetch(window.routes.cartChangeUrl + '.js', {
      body: JSON.stringify({ line: line, quantity: quantity }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
  })
}

function changeItemAndRerenderCart(line, quantity, hideCheckboxes = false) {
  changeItem(line, quantity)
    .then(() => {
      fetch(Shopify.routes.root + 'cart')
          .then(res => res.text())
          .then(html =>{
            if (document.querySelector('body.template-cart')) {
              // Re-render the cart page content
              let parser = new DOMParser();
              let fetchedDoc = parser.parseFromString(html, 'text/html');
              let newCart = fetchedDoc.querySelector('.PageContent');
              let oldCart = document.querySelector('.PageContent');
              if (newCart && oldCart) {
                if (hideCheckboxes){
                  // If the gift box was removed, hide the gift box checkboxes
                  let giftboxes = newCart.querySelectorAll('[id^="gift_box-"]');
                  let lineItemsToUpdate = [];
                  giftboxes.forEach(box => {
                    if (box.checked) {
                      // We need to remove the custom property from the line items which have it on true
                      lineItemsToUpdate.push(box);
                      box.checked = false;
                    }
                  });
                  if (lineItemsToUpdate.length > 0) {
                    // Remove the custom property from the line items which have it on true
                    // Prevent checkout button to be submitted
                    document.querySelector('button.Cart__Checkout').setAttribute('disabled', true);
                    removeGiftBoxCustomProperty(lineItemsToUpdate, 0);
                  }
                } else {
                  newCart?.classList.add('show-checkboxes');
                }

                oldCart.replaceWith(newCart);
              } else {
                // Removal of the last line item, redirect to cart page
                window.location.href = window.routes.cartUrl;
              }
            } else {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
              }));
              let giftboxes = document.querySelectorAll('[id^="gift_box-"]');
              let lineItemsToUpdate = [];
              giftboxes.forEach(box => {
                if (box.checked) {
                  // We need to remove the custom property from the line items which have it on true
                  lineItemsToUpdate.push(box);
                  box.checked = false;
                }
              });
              if (lineItemsToUpdate.length > 0) {
                // Remove the custom property from the line items which have it on true
                // Prevent checkout button to be submitted
                document.querySelector('button.Cart__Checkout').setAttribute('disabled', true);
                removeGiftBoxCustomProperty(lineItemsToUpdate, 0);
                }
            }
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
    });
}

function getLineItem(id, quantity, gift){
  // {
  //     id: id,
  //     properties: { '_gift_box': true } // The _ first so the custom property is hidden in the cart
  // }
  let obj = {
      id: id,
      quantity: quantity,
      properties: { '_gift_box': gift }
  }

  return obj;
}

function removeGiftBoxCustomProperty(giftBoxes, index) {
  if (index < giftBoxes.length) {
    const id = giftBoxes[index].id.split('-')[1];
    const quantity = giftBoxes[index].getAttribute('data-quantity');
    const itemObj = getLineItem(id, quantity, false);
    fetch(Shopify.routes.root + 'cart/change.js', POST_BODY(itemObj))
        .then(() => {
            // Recursively process the next gift box
            removeGiftBoxCustomProperty(giftBoxes, index + 1);
        })
        .catch(err => {
            console.error(err);
        });
  } else {
    // All gift boxes have been processed, re-enable the checkout button
    document.querySelector('button.Cart__Checkout').removeAttribute('disabled');
  }
}